module.exports = __webpack_public_path__ + "img/nou-horta.8731b872.svg";